import React from 'react'
import { QualityBadgeProps } from './QualityBadge.types'
import { Badge } from './QualityBadge.styles'

export const QualityBadge: React.FC<QualityBadgeProps> = ({
  qualityClass,
  children,
  className,
  style,
}) => {
  return (
    <Badge $class={qualityClass} className={className} style={style}>
      {children}
    </Badge>
  )
}

QualityBadge.displayName = 'QualityBadge'
